import React, { useState, useEffect } from 'react';
import './Css/PublishPaper.css';
import { useLocation, useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

const PreviewPaper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.paperId || location.pathname.split("/").pop();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [publishing, setPublishing] = useState(false);

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const handleConfirm = () => {
    setShowConfirmPopup(false);
    setShowSuccessPopup(true);
  };

  const handleCancel = () => {
    setShowConfirmPopup(false);
  };

  const [paper, setPaper] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaper = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/Papers/preview/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
            }
          }
        );

        const data = await res.json();
        console.log(data, "preview");
        setPaper(data);

        setPaper(data);
      } catch (err) {
        console.error("Preview load failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPaper();
  }, [id]);

  if (loading) return <div className="preview-paper-container">Loading...</div>;
  if (!paper) return <div className="preview-paper-container">Paper not found</div>;

  const formatDate = d =>
    new Date(d).toLocaleDateString("mr-IN", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });

  const formatTime = t => t?.substring(0, 5);

  const getOptionLabel = (i, type) => {
    const map = {
      1: ["A", "B", "C", "D"],
      2: ["a", "b", "c", "d"],
      4: ["1", "2", "3", "4"],
      8: ["१", "२", "३", "४"],
      16: ["I", "II", "III", "IV"]
    };
    return map[type]?.[i] || ["A", "B", "C", "D"][i];
  };

  return (
    <div className="preview-paper-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन &gt;&gt; <span>परीक्षा पहा</span>
        </h3>

        <div className="preview-publish-button">
          <button onClick={() => setShowConfirmPopup(true)}>निश्चित करा </button>
        </div>
      </div>
      <header className="preview-header">
        <div className="preview-header-left">
          <p>(दिनांक-{formatDate(paper.paperDate)})</p>
          <p>(वेळ : {formatTime(paper.startTime)} - {formatTime(paper.endTime)})</p>
        </div>

        <div className="preview-title">
          <h2>{paper.title} – इयत्ता {paper.standard}</h2>
        </div>

        <div className="preview-header-right">
          (गुण-{paper.totalMarks})
        </div>
      </header>
      <section className="preview-instructions">
        <strong>सामान्य सूचना:-</strong>
        <ol>
          {paper.instruction?.split("\n").map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ol>
      </section>

      <section className="preview-questions">
        {paper.questions.map((q, qi) => (
          <div className="preview-question" key={q.questionId}>
            <p>
              {qi + 1}) {q.questionText}

              {q.questionImage && (
                <div>
                  <img src={q.questionImage} alt="" style={{ maxWidth: 200 }} />
                </div>
              )}
              <ul>
                {q.options
                  ?.filter(opt => opt && (opt.text || opt.image))
                  .map((opt, oi) => (
                    <li key={oi}>
                      {getOptionLabel(oi, paper.answerSelectionType)}) {opt.text}

                      {opt.image && (
                        <div>
                          <img src={opt.image} alt="" style={{ maxWidth: 150 }} />
                        </div>
                      )}
                    </li>
                  ))}

              </ul>
            </p>
          </div>
        ))}
      </section>



      {/* Confirm Popup */}
      {showConfirmPopup && (
        <div className="confirm-popup-overlay">
          <div className="confirm-popup-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 100 100" fill="none">
              <path d="M44.0062 66.2823L70.6573 39.6313L67.7083 36.6823L44.0062 60.3844L32.1312 48.5094L29.1823 51.4583L44.0062 66.2823ZM50.0135 87.5C44.8281 87.5 39.9528 86.516 35.3875 84.5479C30.8229 82.5799 26.8521 79.909 23.475 76.5354C20.0979 73.1618 17.4247 69.1944 15.4552 64.6333C13.4851 60.0729 12.5 55.1997 12.5 50.0135C12.5 44.8281 13.484 39.9528 15.4521 35.3875C17.4201 30.8229 20.091 26.8521 23.4646 23.475C26.8382 20.0979 30.8056 17.4247 35.3667 15.4552C39.9271 13.4851 44.8003 12.5 49.9865 12.5C55.1719 12.5 60.0472 13.484 64.6125 15.4521C69.1771 17.4201 73.1479 20.091 76.525 23.4646C79.9021 26.8382 82.5753 30.8056 84.5448 35.3667C86.5149 39.9271 87.5 44.8003 87.5 49.9865C87.5 55.1719 86.516 60.0472 84.5479 64.6125C82.5799 69.1771 79.909 73.1479 76.5354 76.525C73.1618 79.9021 69.1944 82.5753 64.6333 84.5448C60.0729 86.5149 55.1997 87.5 50.0135 87.5Z" fill="#2563EB" />
            </svg>
            <h2 className="confirm-popup-title">"तुम्हाला खात्री करायची आहे का?"</h2>
            <p className="confirm-popup-message">
              "तुम्हाला खरंच पुढे जायचं आहे का? नंतर हे बदलता येणार नाही."            </p >

            <div className="confirm-popup-actions">
              <button className="confirm-popup-cancel" onClick={handleCancel}>रद्द करा </button>
              <button
                className="confirm-popup-confirm"
                onClick={handleConfirm}
                disabled={publishing}
              >
                {publishing ? "Publishing..." : "निश्चित करा"}
              </button>

            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="success-popup-overlay">
          <div className="success-popup-box">

            <div className="success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 100 100" fill="none">
                <path d="M44 66L70 40L66 36L44 58L34 48L30 52L44 66ZM50 90C27.9 90 10 72.1 10 50C10 27.9 27.9 10 50 10C72.1 10 90 27.9 90 50C90 72.1 72.1 90 50 90Z" fill="#2563EB" />
              </svg>
            </div>

            <h2 className="success-title">"परीक्षा यशस्वीरीत्या तयार झाली!"</h2>

            <div className="success-details">
              <p>{paper.title}</p>
              <p>इयत्ता : {paper.standard}</p>
              <p>विषय : {paper.subject}</p><p>दिनांक : {formatDate(paper.paperDate)}</p><p>वेळ : {formatTime(paper.startTime)} ते {formatTime(paper.endTime)}</p>
              <p>कालावधी : {
                Math.round(
                  (new Date(`1970-01-01T${paper.endTime}`) -
                    new Date(`1970-01-01T${paper.startTime}`)) / 3600000
                )
              } तास</p>
              <p>गुण : {paper.totalMarks}</p>
            </div>

            <div className="success-actions">
              <button
                className="success-outline-btn"
                onClick={async () => {
                  try {
                    const res = await fetch(
                      `${API_BASE}/api/Papers/${id}/save`,
                      {
                        method: "POST",
                        headers: {
                          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
                        }
                      }
                    );

                    if (!res.ok) throw new Error();

                    setShowSuccessPopup(false);
                    navigate("/dashboard/exammanagment");

                  } catch {
                    alert("Save failed");
                  }
                }}
              >
                जनन करा आणि परीक्षेवर परत जा
              </button>

              <button
                className="success-primary-btn"
                onClick={async () => {
                  try {
                    const res = await fetch(
                      `${API_BASE}/api/Papers/${id}/publish`,
                      {
                        method: "POST",
                        headers: {
                          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
                        }
                      }
                    );

                    if (!res.ok) throw new Error();

                    navigate("/dashboard/exammanagment");

                  } catch {
                    alert("Publish failed");
                  }
                }}
              >
                प्रकाशित करा
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default PreviewPaper;
